import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../item/requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemKeys } from '../item/registerItemKeys'

export const useImportRegisterItemsCsvAsync = (
  options?: UseMutationOptions<
    { uploadJobId?: number },
    RequestErrorType,
    RequestTypes['importRegisterItemsCsv']
  >,
) => {
  return useMutation({
    ...registerItemKeys.uploadRegisterItems,
    ...options,
  })
}
